module.exports = __webpack_public_path__ + "static/ImagePlaceholder2-508fd7feeb9fe9e08f4dec6384d5d5e4.png";